import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13m5-3.2a11 11 0 0 0 2-1.314V7.514A11 11 0 0 0 21 6.2zm-2 .786V5.414a11 11 0 0 0-2-.37v21.911a11 11 0 0 0 2-.37M27 16c0 2.355-.74 4.537-2 6.326V9.674c1.26 1.79 2 3.971 2 6.326M15 5.045C9.393 5.55 5 10.262 5 16s4.393 10.45 10 10.955z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCircleHalf = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCircleHalf);
export default Memo;
